import { useTranslation } from 'react-i18next';
import { SentryErrorBoundary } from '@/lib/sentry';

function RootErrorFallback() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 p-8 text-center">
      <h1 className="text-2xl font-semibold text-slate-800">{t('errors.root.title')}</h1>
      <p className="max-w-md text-sm text-slate-600">{t('errors.root.description')}</p>
      <button
        onClick={() => window.location.reload()}
        className="rounded-md bg-[color:var(--color-terra-600)] px-4 py-2 text-sm font-medium text-[color:var(--color-paper)] hover:bg-[color:var(--color-terra-700)]"
      >
        {t('errors.root.reload')}
      </button>
    </div>
  );
}

export function RootErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <SentryErrorBoundary fallback={<RootErrorFallback />} showDialog={false}>
      {children}
    </SentryErrorBoundary>
  );
}
